import {useEffect, useState } from 'react';
import type {Camera} from "@/services/Camera";
import {getCameraDonVi} from "@/services/Camera/camera";
import {Pagination} from "antd";

type ApiParamProps = {
  page?: number;
  limit?: number;
}

export default () => {
  const [danhSach, setDanhSach] = useState<Camera.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);
  const [donVi, setDonVi] = useState<any>(null);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const getDanhSachCameraDonVi = async (donViId?: string,options?: ApiParamProps) => {
    setRefresh(false);
    setLoading(true);
    const idDonVi = donViId || cond?.organizationId;
    setDonVi(idDonVi);
    const response = await getCameraDonVi({ page: options?.page || page, limit: options?.limit || limit, cond, donViId: idDonVi });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  useEffect(() => {
    if (refresh){
      getDanhSachCameraDonVi(donVi);
    }
  },[refresh]);
  return {
    danhSach,
    loading,
    setLoading,
    total,
    setTotal,
    setRefresh,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setDanhSach,
    getDanhSachCameraDonVi
  };
};
